import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { FONTS, fontSize } from "../../../styles/fonts";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { ExpandedStoryTeaser } from "../../../layouts/stories/stories-overview-page/stories-overview-page-layout";

export const StyledStorySeoHeadline = styled.h2(
  FONTS.SwarovskiFutura500,
  fontSize.x2s,
  css`
    color: ${CSS_COLORS.Black};
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 8px;
  `,
);

export const StyledStoryEmoHeadline = styled.h3(
  FONTS.MinervaModern500,
  fontSize.x3,
  css`
    color: ${CSS_COLORS.Green};
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 15px;
  `,
);

export const StyledStoryTime = styled.span(
  FONTS.SwarovskiFutura300,
  fontSize.x2s,
  css`
    color: rgba(0, 0, 0, 0.9);
    margin-top: 8px;
    display: block;

    margin-bottom: 0;
  `,
);

export const StyledStoryTagsList: ReactTFC<{ tags: NonEmptyArray<ExpandedStoryTeaser["tags"][0]> }> = props => {
  return (
    <div
      className="u-flex u-flex-wrap"
      css={css`
        --g: 12px;
        --w: 2px;
        gap: var(--g);
      `}
    >
      {props.tags.map((t, idx) => (
        <SwarovskiLink
          isInternal={true}
          expectSimilarLayout={true}
          scrollToTop={true}
          link={t.expandedLink}
          attachStyles={css`
            color: ${CSS_COLORS.Black};
            font-weight: 500;
            line-height: 1;

            position: relative;
            &:after {
              content: "";
              position: absolute;
              right: calc(-0.5 * var(--g) - 0.5 * var(--w));
              top: 0;
              height: 100%;
              width: var(--w);

              background-color: ${CSS_COLORS.Black};
            }

            &:last-child {
              &:after {
                display: none;
              }
            }
          `}
          key={idx}
        >
          {t.label}
        </SwarovskiLink>
      ))}
    </div>
  );
};
